// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Region
 */
export interface Region {
  /**
   *
   * @type {string}
   * @memberof Region
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Region
   */
  displayName: string;
}

/**
 * Check if a given object implements the Region interface.
 */
export function instanceOfRegion(value: object): value is Region {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('displayName' in value) || value['displayName'] === undefined)
    return false;
  return true;
}

export function RegionFromJSON(json: any): Region {
  return RegionFromJSONTyped(json, false);
}

export function RegionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Region {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    displayName: json['display_name'],
  };
}

export function RegionToJSON(json: any): Region {
  return RegionToJSONTyped(json, false);
}

export function RegionToJSONTyped(
  value?: Region | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    display_name: value['displayName'],
  };
}
